// hooks/useUnsavedChangesWarning.ts

import { useCallback } from 'react';
import { useBeforeUnload } from 'react-router-dom';

/**
 * Custom hook to warn users about unsaved changes when they try to navigate away.
 * @param isFormDirty - Boolean indicating if the form has unsaved changes.
 */
const useUnsavedChangesWarning = (isFormDirty: boolean) => {
  // Handle browser page unload (e.g., refresh or close)

  const handleBeforeUnload = useCallback(
    (event: BeforeUnloadEvent) => {
      if (isFormDirty) {
        return event.preventDefault();
      }
    },
    [isFormDirty]
  );

  useBeforeUnload(handleBeforeUnload);
};

export default useUnsavedChangesWarning;
